import {FormHelper} from "../../../../Commons/Scripts/Utils";
import IconButton from "../../../../Commons/Scripts/Componentes/IconButton/IconButton";
import ToolTip from "../../../../Commons/Scripts/Componentes/ToolTip/Tooltip";
import {SvgComponent} from "../../../../Commons/Scripts/Componentes";
import {AnimatedIconButton} from "../../../../Commons/Scripts/Componentes/AnimatedIconButton/AnimatedIconButton";
import '../../../../App/src/Assets/css/light-bootstrap-dashboard-pro-react.min.css'

import { useState, useEffect, useRef } from 'react'
import { Button, Card, Form, Container, Col } from 'react-bootstrap';

export function ForgotPasswordPage({
  showLoading,
  hideLoading,
  setIsForgotPassword,
  theme,
}) {
  const [cardClasses, setCardClasses] = useState("card-hidden");
  const [form, setForm] = useState({
    email: "",
    Codigo: "",
  });
  const onInputChange = (e) => {
    FormHelper.handleChange(e, setForm);
  };

  const onSubmit = (e) => {
    showLoading();
    enviarCorreoCambioContrasena(form.email, form.Codigo);
  };
  const cardRef = useRef(null);
  useEffect(() => {
    if (cardRef.current) {
      cardRef.current.style.setProperty('min-width', '20rem', 'important');
    }
    setTimeout(function () {
      setCardClasses("");
    }, 500);
  }, []);

  return (
    <>
      <div className="full-page section-image" data-color="black">
        <div className="content d-flex align-items-center p-0">
        <Container style={{ maxWidth: "65%", minWidth: "65%" }}>
            <Col className="mx-auto" style={{ maxWidth: "min-content" }}>
              <Form className="form" onSubmit={onSubmit}>
                <Card
                    ref={cardRef}
                    className={"card-login " + cardClasses} style={{}}>
                  <IconButton
                    styles={{
                      position: "absolute",
                      padding: "0",
                      marginLeft: "5px",
                      marginTop: '-5px'
                    }}
                    onClick={() => setIsForgotPassword(false)}
                  >
                    <ToolTip message="Volver">
                      <div>
                        <SvgComponent
                          iconName="back"
                          height="25"
                          width="25"
                          fill={theme.color1}
                          style={{ marginLeft: "5px" }}
                        />
                      </div>
                    </ToolTip>
                  </IconButton>
                  <Card.Header className="text-center" style={{
                    borderBottom: '1px solid #0000000d'
                  }}>
                    {theme.logo ? (
                      <img
                        alt="logo"
                        style={{ objectFit: "contain" }}
                        src={theme.logo}
                        height="80px"
                        width="275px"
                      />
                    ) : (
                      theme.appName
                    )}
                  </Card.Header>
                  <Card.Body
                    className="d-flex"
                    style={{
                      flexDirection: "column",
                      alignContent: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Form.Group className='form-group'>
                      <label>Correo Electrónico</label>
                      <Form.Control
                        name="email"
                        type="text"
                        value={form.email}
                        onChange={onInputChange}
                        placeholder="Correo del usuario registrado"
                      />
                    </Form.Group>
                    <Form.Group className='form-group'>
                      <label>Código Compañía</label>
                      <Form.Control
                        name="Codigo"
                        type="text"
                        value={form.Codigo}
                        onChange={onInputChange}
                      />
                    </Form.Group>
                  </Card.Body>
                  <Card.Footer
                    className="d-flex"
                    style={{ justifyContent: "space-around" }}
                  >
                    <AnimatedIconButton
                      size="60px"
                      height="35px"
                      width="35px"
                      iconName="lock"
                      message="Proceder"
                      onClick={(e) => onSubmit(e)}
                      useVendorTheme={true}
                    />
                  </Card.Footer>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
      </div>
    </>
  );
}
